module.exports = __webpack_public_path__ + "img/ic-coupon.0e8bdfd3.png";